import { createContext, useContext } from 'react';

import type { AgencyConfigurationDto } from '@ngsos/portal-core/agency';

const AgencyConfigurationContext = createContext<AgencyConfigurationDto | null>(null);

export const AgencyConfigurationContextProvider = AgencyConfigurationContext.Provider;

export function useAgencyConfiguration(): AgencyConfigurationDto {
  const configuration = useContext(AgencyConfigurationContext);
  if (!configuration) {
    throw new Error('useAgencyConfiguration must be used within AgencyConfigurationProvider');
  }

  return configuration;
}
